(() => {
  if(window.BizedealsPrimePromo)return;
  let timer;
  function active(node,now=Date.now()) {
    const until=Number(node.dataset.primeUntil),link=node.querySelector('a[href]');
    if(node.dataset.primeRelevant!=='true'||!Number.isFinite(until)||until<0||(until&&until*1000<=now)||!link)return false;
    try{const url=new URL(link.href);return url.protocol==='https:'&&['www.amazon.com','amazon.com'].includes(url.hostname)&&['/prime','/amazonprime'].includes(url.pathname)&&!url.username&&!url.password&&!url.port&&/^[a-z0-9][a-z0-9-]{1,79}-20$/.test(url.searchParams.get('tag')||'');}catch{return false;}
  }
  function refresh(scope=document) {
    const now=Date.now();scope.querySelectorAll('[data-prime-promo]').forEach(node=>node.hidden=!active(node,now));
    clearTimeout(timer);const ends=[...document.querySelectorAll('[data-prime-promo]')].map(n=>Number(n.dataset.primeUntil)*1000).filter(t=>t>now);
    if(ends.length)timer=setTimeout(()=>refresh(),Math.min(Math.min(...ends)-now+10,2147483647));
  }
  window.BizedealsPrimePromo={refresh};
  document.addEventListener('visibilitychange',()=>refresh());
  window.addEventListener('pageshow',()=>refresh());
  document.addEventListener('shopify:section:load',()=>refresh());
  document.addEventListener('click',event=>{const node=event.target.closest?.('[data-prime-promo]');if(node&&!active(node)){event.preventDefault();node.hidden=true;}},true);
  refresh();
})();
